<template>
    <div class="living-options-properties">
      <div class="row">
        <div class="col-12">
          <div class="properties">
            <h5>Properties</h5>
            <button class="btn btn-primary mb-4" @click="addProperty()" :disabled="isAddingNewObject('properties')">Add Property</button>
            <div>
              Filter Properties
              <input class="mb-4" type="text" v-model="propertiesFilterText" placeholder="Salt 101">
            </div>

            <table>
              <thead>
                <tr>
                  <th>Label</th>
                  <th>Status</th>
                  <th>Builder</th>
                  <th>Design</th>
                  <th>Total Package Price</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="property in filteredProperties"
                  :key="property._id"
                >
                  <td><span v-if="property.isFromCRM" class="tag-crm">CRM</span> {{ property.label }}</td>
                  <td>{{ property.status }}</td>
                  <td>{{ property.builder }}</td>
                  <td>{{ property.design }}</td>
                  <td>{{ property.total_package_price }}</td>
                  <td class="text-right table__button-cell">
                    <button class="btn btn-sm btn-outline-danger ml-1" @click="deleteProperty(property._id)">Delete</button>
                    <button class="btn btn-sm btn-outline-secondary ml-1" @click="cloneProperty(property._id)">Clone</button>
                    <button class="btn btn-sm btn-primary ml-1" @click="activePropertyId = property._id">Edit</button>
                  </td>
                </tr>
              </tbody>
            </table>

            <modal-popup :isVisible="!!activeProperty">
              <div v-if="activeProperty" class="modal-row-padding" v-click-outside="closeModal">
                <div v-if="activeProperty.isFromCRM">
                  <span class="tag-crm ml-0 mb-3">CRM</span>
                </div>

                <div class="row">
                  <div v-if="userAccess.indexOf('propertyLabel') !== -1" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activeProperty.isFromCRM }"></span>Label</label>
                      <div v-if="activePropertyId !== activeProperty._id">{{ activeProperty.label }}</div>
                      <input
                        v-else
                        type="text"
                        class="form-control form-control-lg"
                        v-model="activeProperty.label"
                        placeholder="i.e. apartment"
                        :disabled="activePropertyId !== activeProperty._id"
                      />
                    </fieldset>
                  </div>
                  <div v-if="userAccess.indexOf('propertyStatus') !== -1" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activeProperty.isFromCRM }"></span>Status</label>
                      <div v-if="activePropertyId !== activeProperty._id">{{ activeProperty.status }}</div>
                      <input
                        v-else
                        type="text"
                        class="form-control form-control-lg"
                        v-model="activeProperty.status"
                        placeholder="i.e. For Sale"
                        :disabled="activePropertyId !== activeProperty._id"
                      />
                    </fieldset>
                  </div>
                  <div v-if="userAccess.indexOf('propertyDesign') !== -1" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activeProperty.isFromCRM }"></span>Design</label>
                      <div v-if="activePropertyId !== activeProperty._id">{{ activeProperty.design }}</div>
                      <input
                        v-else
                        type="text"
                        class="form-control form-control-lg"
                        v-model="activeProperty.design"
                        placeholder="i.e. Custom"
                      />
                    </fieldset>
                  </div>
                  <div v-if="userAccess.indexOf('propertyBuilder') !== -1" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activeProperty.isFromCRM }"></span>Builder</label>
                      <div v-if="activePropertyId !== activeProperty._id">{{ activeProperty.builder }}</div>
                      <input
                        v-else
                        type="text"
                        class="form-control form-control-lg"
                        v-model="activeProperty.builder"
                        placeholder="i.e. Metricon"
                        :disabled="activePropertyId !== activeProperty._id"
                      />
                    </fieldset>                                                    
                  </div>
                  <div v-if="userAccess.indexOf('propertyLivingMsq') !== -1 && activeProperty.stock_type == 'Terrace'" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activeProperty.isFromCRM }"></span>Living m<sup>2</sup></label>
                      <div v-if="activePropertyId !== activeProperty._id">{{ activeProperty.building_area_msq }}</div>
                      <input
                        v-else
                        type="number"
                        class="form-control form-control-lg"
                        v-model="activeProperty.building_area_msq"
                        placeholder="i.e. 55"
                        :disabled="activePropertyId !== activeProperty._id"
                      />
                    </fieldset>                                                    
                  </div>
                  <div v-if="userAccess.indexOf('propertyLivingMsq') !== -1 && activeProperty.stock_type == 'Apartment'" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activeProperty.isFromCRM }"></span>Living m<sup>2</sup></label>
                      <div v-if="activePropertyId !== activeProperty._id">{{ activeProperty.living_msq }}</div>
                      <input
                        v-else
                        type="number"
                        class="form-control form-control-lg"
                        v-model="activeProperty.living_msq"
                        placeholder="i.e. 55"
                        :disabled="activePropertyId !== activeProperty._id"
                      />
                    </fieldset>                                                    
                  </div>
                  <div v-if="userAccess.indexOf('propertyOutdoorMsq') !== -1 && activeProperty.stock_type == 'Apartment'" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activeProperty.isFromCRM }"></span>Outdoor m<sup>2</sup></label>
                      <div v-if="activePropertyId !== activeProperty._id">{{ activeProperty.outdoor_msq }}</div>
                      <input
                        v-else
                        type="number"
                        class="form-control form-control-lg"
                        v-model="activeProperty.outdoor_msq"
                        placeholder="i.e. 55"
                        :disabled="activePropertyId !== activeProperty._id"
                      />
                    </fieldset>                                                    
                  </div>
                  <div v-if="userAccess.indexOf('propertyLandareaMsq') !== -1 && activeProperty.stock_type == 'Terrace'" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activeProperty.isFromCRM }"></span>Land Area m<sup>2</sup></label>
                      <div v-if="activePropertyId !== activeProperty._id">{{ activeProperty.landarea_msq }}</div>
                      <input
                        v-else
                        type="number"
                        class="form-control form-control-lg"
                        v-model="activeProperty.landarea_msq"
                        placeholder="i.e. 55"
                        :disabled="activePropertyId !== activeProperty._id"
                      />
                    </fieldset>                                                    
                  </div>
                  <div v-if="userAccess.indexOf('propertyMsq') !== -1 && activeProperty.stock_type == 'Apartment'" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activeProperty.isFromCRM }"></span>Total m<sup>2</sup></label>
                      <div v-if="activePropertyId !== activeProperty._id">{{ activeProperty.msq }}</div>
                      <input
                        v-else
                        type="number"
                        class="form-control form-control-lg"
                        v-model="activeProperty.msq"
                        placeholder="i.e. 85"
                        :disabled="activePropertyId !== activeProperty._id"
                      />
                    </fieldset>                                                    
                  </div>
                  <div v-if="userAccess.indexOf('propertyPrice') !== -1 && activeProperty.stock_type == 'Apartment'" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activeProperty.isFromCRM }"></span>Price</label>
                      <div v-if="activePropertyId !== activeProperty._id">{{ activeProperty.price }}</div>
                      <input
                        v-else
                        type="number"
                        class="form-control form-control-lg"
                        v-model="activeProperty.price"
                        placeholder="i.e. 300000"
                        :disabled="activePropertyId !== activeProperty._id"
                      />
                    </fieldset>                                                    
                  </div>
                  <div v-if="userAccess.indexOf('propertyLandPrice') !== -1" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activeProperty.isFromCRM }"></span>Land Price</label>
                      <div v-if="activePropertyId !== activeProperty._id">{{ activeProperty.land_price }}</div>
                      <input
                        v-else
                        type="number"
                        class="form-control form-control-lg"
                        v-model="activeProperty.land_price"
                        placeholder="i.e. 200000"
                        :disabled="activePropertyId !== activeProperty._id"
                      />
                    </fieldset>                                                    
                  </div>
                  <div v-if="userAccess.indexOf('propertyTotalPackagePrice') !== -1 && activeProperty.stock_type == 'Terrace'" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activeProperty.isFromCRM }"></span>Total Package Price</label>
                      <div v-if="activePropertyId !== activeProperty._id">{{ activeProperty.total_package_price }}</div>
                      <input
                        v-else
                        type="number"
                        class="form-control form-control-lg"
                        v-model="activeProperty.total_package_price"
                        placeholder="i.e. 500000"
                        :disabled="activePropertyId !== activeProperty._id"
                      />
                    </fieldset>                                                    
                  </div>
                </div>

                <div class="row">
                  <div class="col-6" v-if="userAccess.indexOf('propertyImages') !== -1"  >
                    <fieldset class="form-group">
                      <label><span class="dot"></span>Images</label>
                      <input-asset v-model="activeProperty.images" :multiple="true" defaultCategory="pageBackground" requirements="Required dimensions: 3040x1960px<br>Supported formats: jpg, png"></input-asset>
                    </fieldset>
                  </div>

                  <div v-if="userAccess.indexOf('propertyModelIds') !== -1" class="col-6">
                    <fieldset class="form-group">
                      <label><span class="dot"></span>Associated Property Models</label>
                      <div class="associated-model-list">
                        <ul v-if="activeProperty.modelIds.length">
                          <li v-for="model in propertyModelsByIds(activeProperty.modelIds)">{{ model.label }}</li>
                        </ul>
                        <div v-else>No associated property models</div>
                      </div>
                      <select v-model="activeProperty.modelIds" class="associated-model-select" multiple>
                        <option v-for="model in propertyModels" :value="model._id">{{ model.label }}</option>
                      </select>
                    </fieldset>
                  </div>

                  <div class="col-12">
                    <button v-if="activePropertyId !== activeProperty._id" class="" @click="activePropertyId = activeProperty._id">Edit</button>
                    <button v-if="activePropertyId === activeProperty._id" class="btn btn-sm btn-outline-danger" @click="activePropertyId = null">Cancel</button>
                    <button v-if="activePropertyId === activeProperty._id" class="btn btn-sm btn-primary ml-1" @click="saveActiveProperty()">Save</button>
                  </div>
                </div>
              </div>             
            </modal-popup>          
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import _ from 'lodash'
import InputAsset from '@/components/InputAsset'
import InputMultiSelect from '@/components/InputMultiSelect'
import ModalPopup from '@/components/ModalPopup'
import CkEditor from '@/components/CKEditor'

export default {
  components: { CkEditor, InputAsset, InputMultiSelect },
  data () {
    return {
      activePropertyId: null,
      propertiesFilterText: '',
    }
  },

  computed: {
    activeProperty () {
      return _.find(this.properties, property => {
        return property._id === this.activePropertyId
      })
    },

    filteredProperties () {
      return _.filter(this.properties, property => {
        return property.label.toLowerCase().includes(this.propertiesFilterText.toLowerCase())
      })
    },

    properties: {
      get () {
        return this.$store.getters.properties
      },
      set (properties) {
        this.$store.commit('SET_PROPERTIES', properties)
      }
    },

    propertyModels: {
      get () {
        return this.$store.getters.propertyModels
      },
      set (properties) {
        this.$store.commit('SET_PROPERTY_MODELS', propertyModels)
      }
    },

    userAccess () {
      return this.$store.getters.user.access ? this.$store.getters.user.access : []
    }
  },

  methods: {
    addProperty () {
      const property = {
        _id: 'temp',
        label: '',
        displayName: '',
        marker: {
          x: 100,
          y: 100
        },
        price: '',
        status: '',
        images: [],
        modelIds: [],
        draft: false,
        msq: null,
        view: ''
      }
      this.$store.commit('ADD_PROPERTY', property)
      this.activePropertyId = property._id
    },

    cloneProperty (id) {
      const property = _.find(this.properties, property => {
        return property._id === id
      })

      let clonedProperty = _.clone(property)

      clonedProperty._id = 'temp'
      clonedProperty.label += '-COPY'
      clonedProperty.isFromCRM = false

      this.$store.commit('ADD_PROPERTY', clonedProperty)
      this.activePropertyId = clonedProperty._id
    },
    
    closeModal () {
      this.$store.dispatch('FETCH_PROPERTIES')
      this.activePropertyId = null
    },

    deleteProperty (id) {
      this.$store.dispatch('DELETE_PROPERTY', id)
    },

    propertiesByIds (ids) {
      const properties =  _.filter(this.properties, property => {
        return ids.includes(property._id)
      })
      return properties
    },    

    propertyModelsByIds (ids) {
      const models =  _.filter(this.propertyModels, model => {
        return ids.includes(model._id)
      })
      return models
    },

    isAddingNewObject () {
      return Boolean(_.map(this.properties, property => { return property._id }).includes('temp'))
    },

    saveActiveProperty () {
      this.$store.dispatch('SAVE_PROPERTY', this.activeProperty)
      this.activePropertyId = null
    },   
  },

  created () {
    this.$store.dispatch('FETCH_ASSETS')
    this.$store.dispatch('FETCH_PROPERTIES')
    this.$store.dispatch('FETCH_PROPERTY_MODELS')
  }
}
</script>
<style lang="scss">
@import "@/styles/_mixins.scss";

  select {
    width: 100%;
  }

  .card {
    z-index: unset !important;
  }

  .living-option, .subsection, .property, .property-model {
    border-radius: 4px;
    padding: 7px;
    border: 1px solid #d4d4d4;
    margin: 1em 0;
  }

  .selection-list {
    border-radius: 4px;
    padding: 7px;
    border: 1px solid #d4d4d4;   
    max-height: 200px;
    // overflow: scroll; 
  }

  .list-wrapper {
    max-height: 600px;
    // overflow: scroll;
  }

  .living-options-property-models,
  .living-options-properties {
    table {
      border-collapse: separate;
      border-spacing: 0;
      border: 1px solid #d4d4d4;
      border-radius: 6px;
      // overflow: hidden;
      width: 100%;
    }

    .table__button-cell button {
      opacity: 0;
    }

    tbody {
      display: block;
      max-height: none;
      overflow: auto;

      @include v-breakpoint(800px) {
        max-height: calc(100vh - 500px);
      }

      tr:hover {
        background-color: #f5f5f5;
        .table__button-cell button {
          opacity: 1;
        }
      }
    }

    thead, tbody tr {
      display: table;
      width: 100%;
      table-layout: fixed;
    }

    thead {
      background-color: #f0f0f0;
      border-bottom: 1px solid #d4d4d4;
      font-size: 12px;
      position: sticky;
      text-transform: uppercase;
      top: 0;
      z-index: 10;
    }

    th, td {
      font-weight: 400;
      padding: 10px 15px;
    }

    tr {
      &:nth-child(2n) {
        background-color: #fafafa;
      }
    }
  }

  .associated-model-list {
    color: #000;

    ul {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        background: #f4f4f4;
        border: 1px solid #e1e1e1;
        border-radius: 3px;
        margin: 0 8px 8px 0;
        padding: 2px 8px;
      }
    }
  }

  .associated-model-select {
    height: 125px;
  }

  .modal-row-padding {
    padding: 30px 0;
  }
</style>